import { useI18n } from "@/i18n/I18nProvider";

const AcceptableUse = () => {
  const { t, tx } = useI18n();
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">{t('legal.aup.title', 'Acceptable Use Policy')}</h1>
      <p className="text-gray-700 mb-4">{t('legal.aup.intro', 'You agree not to use the services for unlawful activities, harassment, spam, or any actions that could harm others, the platform, or our partners.')}</p>
      <ul className="list-disc ml-6 text-gray-700 space-y-2">
        <li>{t('legal.aup.item.fraud', 'No fraudulent or deceptive conduct')}</li>
        <li>{t('legal.aup.item.access', 'No unauthorized access attempts')}</li>
        <li>{t('legal.aup.item.abuse', 'No abuse or harassment of vendors or customers')}</li>
      </ul>
      <p className="text-gray-600 mt-8">{tx('legal.last_updated', { date: today })}</p>
    </div>
  );
};

export default AcceptableUse;
